<template>
  <AppSection id="invoice-details" type="page" :title="$getConst.pages.invoice_details.page_title">
    <b-container>
      <InvoiceDetails :invoice="invoice" :is-loading="isLoading"/>
    </b-container>
  </AppSection>
</template>

<script>
  import AppSection from "../../../components/common/sections/AppSection";
  import {getInvoice} from "../../../api/invoices.api";
  import InvoiceDetails from "./InvoiceDetails";
  export default {
    name: "index",
    components: {InvoiceDetails, AppSection},
    props: {
      invoiceId: null
    },
    data() {
      return {
        isLoading: false,
        invoice: null
      }
    },
    methods: {
      getInvoice() {
        this.isLoading = true;
        getInvoice(this.invoiceId).then(
          (response) => {
            this.invoice = response.data;
            this.isLoading = false;
            console.log(this.invoice);
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      }
    },
    created() {
      this.getInvoice();
    }
  }
</script>

<style scoped>

</style>
